<template>
  <div
    id="sidenav-collapse-main"
    class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100"
  >
    <ul class="navbar-nav">
      <li class="nav-item" :class="getRoute() === 'profile' ? 'active' : ''">
        <sidenav-collapse
          collapse-ref="profile"
          :nav-text="name"
          :class="getRoute() === 'profile' ? 'active' : ''"
        >
          <template #icon>
            <img v-if="profilePic" :src="profilePic" class="avatar" />
            <material-avatar
              v-else
              img=""
              :alt="name"
              :color="user.color"
              size="sm"
              shadow="sm"
              circular
            />
          </template>

          <template #list>
            <ul class="nav pe-0">
              <sidenav-item
                :to="{ name: 'Profile' }"
                mini-icon="S"
                text="Profile"
                @click="toggleSidebar"
              />
              <sidenav-item
                :to="{ name: '/' }"
                mini-icon="L"
                text="Logout"
                @click="logout"
              />
            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" :class="getRoute() === 'new' ? 'active' : ''">
        <sidenav-item
          :to="{ name: 'New Upload' }"
          mini-icon="fa fa-upload"
          text="New Upload"
          @click="toggleSidebar"
        />
      </li>
      <li class="nav-item" :class="getRoute() === 'myfiles' ? 'active' : ''">
        <sidenav-item
          :to="{ name: 'My Files' }"
          mini-icon="fa fa-copy"
          text="My Files"
          @click="toggleSidebar"
        />
      </li>
      <li class="nav-item" :class="getRoute() === 'sharedwithme' ? 'active' : ''">
        <sidenav-item
          :to="{ name: 'Shared With Me' }"
          mini-icon="fa fa-copy"
          text="Shared With Me"
          @click="toggleSidebar"
        />
      </li>
      <li class="nav-item" :class="getRoute() === 'contacts' ? 'active' : ''">
        <sidenav-item
          :to="{ name: 'Contacts' }"
          mini-icon="fa fa-address-book"
          text="Contacts"
          @click="toggleSidebar"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import SidenavItem from "./SidenavItem.vue";
import SidenavCollapse from "./SidenavCollapse.vue";
import { mapState, mapMutations, mapActions } from "vuex/dist/vuex.cjs.js";
import MaterialAvatar from '@/components/ui/MaterialAvatar';

export default {
  name: "SidenavList",
  components: {
    SidenavItem,
    SidenavCollapse,
    MaterialAvatar
  },
  props: {
    minNav: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isActive: "active"
    };
  },
  computed: {
    ...mapState("user", ["user"]),
    ...mapState([
      "isPinned"
    ]),
    profilePic() {
      return this.user && this.user.image ? this.user.image : null;
    },
    name() {
      return this.user ? this.user.name : 'Unknown username';
    },
    color() {
      return this.user ? this.user.color : null;
    }
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    ...mapActions("user", ["logoutAction"]),
    toggleSidebar() {
      if(!this.isPinned) {
        this.navbarMinimize();
      }
    },
    getRoute() {
      return this.$route.path.split("/")[1];
    },
    async logout() {
      await this.logoutAction();
      this.$router.push("/login");
    }
  }
};
</script>
